import { FilePreviewModel } from 'ngx-awesome-uploader';
import { HttpRequest, HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { map } from 'rxjs/operators';
import {ApiConfiguration} from './api-configuration';

export class RequestFilePickerAdapter {
  constructor(private http: HttpClient, requestId,
              private config: ApiConfiguration) {
    this.requestId = requestId;
  }

  requestId;
  public uploadFile(fileItem: FilePreviewModel) {
    const form = new FormData();
    form.append('file', fileItem.file);
    const api = this.config.rootUrl + '/uploadFile/' + encodeURIComponent(this.requestId);
    const req = new HttpRequest('POST', api, form, {reportProgress: true});
    return this.http.request(req);
  }

}
